<template>
	<div :class="['custom-control custom-switch', disabled || options?.disabled ? 'disabled' : '']" :tabindex="disabled || options?.disabled ? false : tabindex" @click="changeValue" @keydown.space="changeValue">
		<input type="checkbox" v-model="localValue" class="custom-control-input" :disabled="disabled || options?.disabled ? true : null" :required="required">
		<label class="custom-control-label"></label>
	</div>
</template>
<script>
	export default {
		props: {
			options: { type: Object, required: false },
			title: {},
			modelValue: { type: [Boolean, String] },
			tabindex: { type: [Number, String] },
			startup: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
			required: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],
		watch: {
			modelValue: {
				handler(val, oldVal) {
					if (val !== oldVal) {
						this.localValue = String(val).toLowerCase() == "true"
					}
				}
			}
		},
		data() {
			return {
				localValue: null
			}
		},
		created() {
			this.localValue = String(this.modelValue).toLowerCase() == "true"

			if (this.params?.options)
				this.localValue = this.params.options?.modelValue
		},
		methods: {
			changeValue: function (e) {
				e.preventDefault()
				if (this.disabled !== true && !this.options?.disabled) {
					this.$emit('update:modelValue', !this.localValue)

					if (this.options && this.options.onChangeHandler) {
						this.options.onChangeHandler(!this.localValue)
					}
				}
			}

		}
	}
</script>
